<template>
    <div class="col-md-12">
        <div class="h2">Configuration</div>
        <div class="h5">Customer journey customization</div>
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>

        <div class="mt-5">
            <table class="table table-bordered table-striped" aria-label="Configuration table">
                <thead>
                    <tr>
                        <th style="width: 34%; font-size: 1.35rem;">VARIABLE</th>
                        <th style="width: 33%; font-size: 1.35rem;">{{ bookingNameBudget }}</th>
                        <th style="width: 33%; font-size: 1.35rem;">{{ bookingNamePrime }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Default time (time)</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center mb-2" v-for="addressType in addressTypes">
                                <div class="address-type-label bold-font">{{ addressType['label'] }}</div>
                                <div class="d-flex align-items-center justify-content-center flex-grow-1">
                                    <div>
                                        <vue-timepicker
                                            manual-input
                                            placeholder="From"
                                            v-model="configurations[bookingType][`default_time_from${addressType['postfix']}`]"
                                            input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                        </vue-timepicker>
                                        <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.default_time_from${addressType['postfix']}`]">
                                            {{ errors[`configurations.${bookingType}.default_time_from${addressType['postfix']}`][0] }}
                                        </div>
                                    </div>
                                    <span class="mx-3">&mdash;</span>
                                    <div>
                                        <vue-timepicker
                                            manual-input
                                            placeholder="To"
                                            v-model="configurations[bookingType][`default_time_to${addressType['postfix']}`]"
                                            input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                        </vue-timepicker>
                                        <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.default_time_to${addressType['postfix']}`]">
                                            {{ errors[`configurations.${bookingType}.default_time_to${addressType['postfix']}`][0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Storage costs (per day - DKK)</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center">
                                <div class="address-type-label bold-font">Dropoff</div>
                                <div class="d-flex align-items-center justify-content-center flex-grow-1">
                                    <input
                                        class="form-control small-input"
                                        type="text"
                                        v-model="configurations[bookingType].storage_cost"
                                    >
                                    <span class="ml-2">kr.</span>
                                </div>
                            </div>
                            <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.storage_cost`]">
                                {{ errors[`configurations.${bookingType}.storage_cost`][0] }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Pickup cost for changed date (per day - DKK)</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center">
                                <div class="address-type-label bold-font">Pickup</div>
                                <div class="d-flex align-items-center justify-content-center flex-grow-1">
                                    <input
                                        class="form-control small-input"
                                        type="text"
                                        v-model="configurations[bookingType].pickup_cost_for_changed_date"
                                    >
                                    <span class="ml-2">kr.</span>
                                </div>
                            </div>
                            <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.pickup_cost_for_changed_date`]">
                                {{ errors[`configurations.${bookingType}.pickup_cost_for_changed_date`][0] }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="mb-4">Opkald fra chauffør inden afhentning</div>
                            <div>Opkald fra chauffør inden levering</div>
                        </td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center mb-2" v-for="addressType in addressTypes">
                                <div class="address-type-label bold-font">{{ addressType['label'] }}</div>
                                <div class="d-flex align-items-center justify-content-center flex-grow-1">
                                    <div>
                                        <div class="mr-5">
                                            <input type="checkbox"
                                                   class="form-control"
                                                   title="Enable an option"
                                                   style="width: 15px;"
                                                   v-model="configurations[bookingType][`call_from_driver${addressType['postfix']}`]['enabled']"
                                            >
                                        </div>
                                        <div class="text-danger mb-1"
                                             v-if="errors[`configurations.${bookingType}.call_from_driver${addressType['postfix']}.enabled`]">
                                            {{ errors[`configurations.${bookingBudget}.call_from_driver${addressType['postfix']}.enabled`][0] }}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="d-flex align-items-center">
                                            <input
                                                class="form-control small-input"
                                                type="text"
                                                v-model="configurations[bookingType][`call_from_driver${addressType['postfix']}`]['price']"
                                            >
                                            <span class="ml-2">kr.</span>
                                        </div>
                                        <div class="text-danger mb-1"
                                             v-if="errors[`configurations.${bookingType}.call_from_driver${addressType['postfix']}.price`]">
                                            {{ errors[`configurations.${bookingType}.call_from_driver${addressType['postfix']}.price`][0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Change address</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center mb-2" v-for="addressType in addressTypes">
                                <div class="address-type-label bold-font">{{ addressType['label'] }}</div>
                                <div class="d-flex align-items-center justify-content-center flex-grow-1">
                                    <div class="d-flex align-items-center justify-content-center">
                                        <input
                                            class="form-control small-input"
                                            type="text"
                                            v-model="configurations[bookingType][`change_address${addressType['postfix']}`]"
                                        >
                                        <span class="ml-2">kr.</span>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}change_address${addressType['postfix']}`]">
                                        {{ errors[`configurations.${bookingType}.change_address${addressType['postfix']}`][0] }}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Converting to a shorter time interval (price (DKK))</td>
                        <td v-for="bookingType in bookingTypes" class="vertical-align-top">
                            <div v-for="(addressType, addressTypeIndex) in addressTypes" class="mb-4">
                                <div class="mb-2 bold-font">{{ addressType['label'] }}</div>
                                <div v-for="(shorter_time_interval, index) in configurations[bookingType][`shorter_time_intervals${addressType['postfix']}`]">
                                    <div class="d-flex align-items-center justify-content-between mb-1">
                                        <div class="align-items-center bg-white border rounded-lg div-focus mr-1" style="width: 30%;">
                                            <v-select
                                                :options="[{name: 'Before', label: 'Før'}, {name: 'After', label: 'Efter'}]"
                                                label="label"
                                                :clearable="false"
                                                v-model="configurations[bookingType][`shorter_time_intervals${addressType['postfix']}`][index]['when']"
                                            >
                                            </v-select>
                                        </div>
                                        <div class="mr-1">
                                            <vue-timepicker
                                                manual-input
                                                placeholder="Time"
                                                hide-clear-button
                                                v-model="configurations[bookingType][`shorter_time_intervals${addressType['postfix']}`][index]['time']"
                                                input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                            </vue-timepicker>
                                        </div>
                                        <div class="mr-1">
                                            <div class="d-flex align-items-center justify-content-center">
                                                <input
                                                    class="form-control small-input"
                                                    type="text"
                                                    id="shorter-time-interval-before-12"
                                                    placeholder="Price"
                                                    v-model="configurations[bookingType][`shorter_time_intervals${addressType['postfix']}`][index]['price']"
                                                >
                                                <span class="ml-2">kr.</span>
                                            </div>
                                        </div>
                                        <div>
                                            <span class="material-icons-outlined text-primary cursor-pointer"
                                                  title="Remove"
                                                  @click="removeShorterTimeInterval(bookingType, index, addressTypeIndex)"
                                            >delete</span>
                                        </div>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.shorter_time_intervals${addressType['postfix']}.${index}.price`]">
                                        {{ errors[`configurations.${bookingType}.shorter_time_intervals${addressType['postfix']}.${index}.price`][0] }}
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.shorter_time_intervals${addressType['postfix']}.${index}.time`]">
                                        {{ errors[`configurations.${bookingType}.shorter_time_intervals${addressType['postfix']}.${index}.time`][0] }}
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.shorter_time_intervals${addressType['postfix']}.${index}.when`]">
                                        {{ errors[`configurations.${bookingType}.shorter_time_intervals${addressType['postfix']}.${index}.when`][0] }}
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <span class="material-icons-outlined text-primary cursor-pointer"
                                          title="Add"
                                          @click="addShorterTimeInterval(bookingType, addressTypeIndex)"
                                    >add_circle</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Shorter time interval cut-off time</td>
                        <td
                            v-for="bookingType in bookingTypes"
                            class="vertical-align-top"
                        >
                            <div v-for="addressType in addressTypes" class="mb-4">
                                <div class="mb-2 bold-font">{{ addressType['label'] }}</div>
                                <div
                                    class="d-flex align-items-center justify-content-between mb-1"
                                    v-if="configurations[bookingType][`shorter_time_interval_cut_off_time${addressType['postfix']}`]"
                                >
                                    <div style="width: 15%">
                                        <input type="checkbox"
                                               class="form-control"
                                               title="Enable an option"
                                               style="width: 15px;"
                                               v-model="configurations[bookingType][`shorter_time_interval_cut_off_time${addressType['postfix']}`]['enabled']"
                                        >
                                    </div>
                                    <div class="flex-grow-1">
                                        <div class="d-flex justify-content-between">
                                            <div>Delivery date</div>
                                            <div class="align-items-center bg-white border rounded-lg div-focus mb-2" style="width: 70%">
                                                <v-select
                                                    :options="[
                                                    {name: today, label: today},
                                                    {name: tomorrow, label: tomorrow},
                                                    {name: dayAfterTomorrow, label: dayAfterTomorrow}
                                                ]"
                                                    :clearable="false"
                                                    @input="changeOption"
                                                    v-model="configurations[bookingType][`shorter_time_interval_cut_off_time${addressType['postfix']}`]['day']"
                                                >
                                                </v-select>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <div>Cut-off at</div>
                                            <div class="mr-1">
                                                <vue-timepicker
                                                    manual-input
                                                    placeholder="Time"
                                                    hide-clear-button
                                                    v-model="configurations[bookingType][`shorter_time_interval_cut_off_time${addressType['postfix']}`]['time']"
                                                    input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                                </vue-timepicker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Fuldmagt (options)</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="mb-2 bold-font">Dropoff</div>
                            <div class="d-flex align-items-center justify-content-center">
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="configurations[bookingType].permits"
                                >
                            </div>
                            <div class="mb-1"><i>Separate option via <strong>;</strong></i></div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="mb-2">Future days to show when choosing new delivery date (future days)</div>
                            <div>(Choosing "want more" customer has to pay for storage costs)</div>
                        </td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center mb-2" v-for="addressType in addressTypes">
                                <div class="address-type-label bold-font">{{ addressType['label'] }}</div>
                                <div class="flex-grow-1">
                                    <div class="d-flex align-items-center justify-content-center mb-1">
                                        <span class="mr-3 pl-3">Default</span>
                                        <input
                                            class="form-control small-input mr-3"
                                            type="text"
                                            v-model="configurations[bookingType][`future_days${addressType['postfix']}`]"
                                        >
                                        <span>Days</span>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.future_days${addressType['postfix']}`]">
                                        {{ errors[`configurations.${bookingType}.future_days${addressType['postfix']}`][0] }}
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center mb-2">
                                        <span class="mr-3">Want more?</span>
                                        <input
                                            class="form-control small-input mr-3"
                                            type="text"
                                            v-model="configurations[bookingType][`want_more${addressType['postfix']}`]"
                                        >
                                        <span>Weeks</span>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.want_more${addressType['postfix']}`]">
                                        {{ errors[`configurations.${bookingType}.want_more${addressType['postfix']}`][0] }}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>SMS-flow cut-off time</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex mb-2" v-for="addressType in addressTypes">
                                <div class="address-type-label bold-font mr-4">{{ addressType['label'] }}</div>
                                <div class="flex-grow-1">
                                    <div class="d-flex justify-content-between">
                                        <div>Delivery date</div>
                                        <div class="align-items-center bg-white border rounded-lg div-focus mb-2" style="width: 70%">
                                            <v-select
                                                :options="[
                                                {name: today, label: today},
                                                {name: tomorrow, label: tomorrow},
                                                {name: dayAfterTomorrow, label: dayAfterTomorrow}
                                            ]"
                                                :clearable="false"
                                                @input="changeOption"
                                                v-model="configurations[bookingType][`sms_flow_cut_off_day${addressType['postfix']}`]"
                                            >
                                            </v-select>
                                        </div>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.sms_flow_cut_off_day${addressType['postfix']}`]">
                                        {{ errors[`configurations.${bookingType}.sms_flow_cut_off_day${addressType['postfix']}`][0] }}
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div>Cut-off at</div>
                                        <div class="mr-1">
                                            <vue-timepicker
                                                manual-input
                                                placeholder=""
                                                v-model="configurations[bookingType][`sms_flow_cut_off_time${addressType['postfix']}`]"
                                                input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                            </vue-timepicker>
                                            <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.sms_flow_cut_off_time${addressType['postfix']}`]">
                                                {{ errors[`configurations.${bookingType}.sms_flow_cut_off_time${addressType['postfix']}`][0] }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Estimated time before driver arrives to customer</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center mb-2" v-for="addressType in addressTypes">
                                <div class="address-type-label bold-font">{{ addressType['label'] }}</div>
                                <div class="d-flex align-items-center justify-content-center flex-grow-1">
                                    <div>
                                        <vue-timepicker
                                            manual-input
                                            placeholder=""
                                            v-model="configurations[bookingType][`estimated_arrival_time${addressType['postfix']}`]"
                                            input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                        </vue-timepicker>
                                        <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.estimated_arrival_time${addressType['postfix']}`]">
                                            {{ errors[`configurations.${bookingType}.estimated_arrival_time${addressType['postfix']}`][0] }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Added time for sheduled_at time from Optimoroute</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center mb-4" v-for="addressType in addressTypes">
                                <div class="address-type-label bold-font">{{ addressType['label'] }}</div>
                                <div class="flex-grow-1">
                                    <div class="d-flex align-items-center justify-content-center mb-2">
                                        <div class="mr-3" style="padding-right: 9px;">Før</div>
                                        <div>
                                            <vue-timepicker
                                                manual-input
                                                placeholder=""
                                                v-model="configurations[bookingType][`added_to_sheduled_at_before${addressType['postfix']}`]"
                                                input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                            </vue-timepicker>
                                            <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.added_to_sheduled_at_before${addressType['postfix']}`]">
                                                {{ errors[`configurations.${bookingType}.added_to_sheduled_at_before${addressType['postfix']}`][0] }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <div class="mr-3">Efter</div>
                                        <div>
                                            <vue-timepicker
                                                manual-input
                                                placeholder=""
                                                v-model="configurations[bookingType][`added_to_sheduled_at_after${addressType['postfix']}`]"
                                                input-class="py-0 ml-0 rounded-1 shadow-none form-input">
                                            </vue-timepicker>
                                            <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.added_to_sheduled_at_after${addressType['postfix']}`]">
                                                {{ errors[`configurations.${bookingType}.added_to_sheduled_at_after${addressType['postfix']}`][0] }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Send sms on test phone number</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="d-flex align-items-center justify-content-center mb-4"
                                 v-for="addressType in addressTypes"
                            >
                                <div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <div class="mr-3 bold-font">{{ addressType['label'] }}</div>
                                        <input type="checkbox"
                                               class="form-control"
                                               style="width: 16px;"
                                               v-model="configurations[bookingType][`send_sms_on_test_number${addressType['postfix']}`]"
                                        >
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.send_sms_on_test_number${addressType['postfix']}`]">
                                        {{ errors[`configurations.${bookingType}.send_sms_on_test_number${addressType['postfix']}`][0] }}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Days NOT available as delivery for customers</td>
                        <td v-for="bookingType in bookingTypes">
                            <div class="mb-2">
                                <button type="button" class="btn btn-primary" @click="clearDates($event, bookingType)">
                                    Clear all
                                </button>
                            </div>
                            <div style="width: fit-content; margin: auto;">
                                <date-picker
                                    :clearable="false"
                                    :multiple="true"
                                    :editable="false"
                                    input-class="content"
                                    valueType="DD-MM-YYYY"
                                    v-model="configurations[bookingType]['not_available_delivery_dates']"
                                    :inline="true"
                                    :lang="datePickerOptions.lang"
                                    :disabled-date="disabledDates"
                                    @change="onDateChange($event, bookingType)">
                                    <template v-slot:icon-clear>
                                        <svg></svg>
                                    </template>
                                    <template v-slot:icon-calendar>
                                        <svg></svg>
                                    </template>
                                </date-picker>
                            </div>
                            <div class="d-flex flex-wrap">
                                <div v-for="date in configurations[bookingType]['not_available_delivery_dates']">
                                    <span class="mr-3">{{ date }}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="mt-5">
            <div class="h4">AUTOPUSH DELIVERY DAY</div>
            <div>
                <table class="table table-bordered table-striped" aria-label="Autopush table">
                    <tr>
                        <td style="width: 34%;">When customer adds a time-variable service</td>
                        <td v-for="bookingType in bookingTypes" style="width: 33%;">
                            <div class="d-flex align-items-center mb-4" v-for="addressType in addressTypes">
                                <div class="address-type-label bold-font">{{ addressType['label'] }}</div>
                                <div class="flex-grow-1">
                                <div class="d-flex align-items-center justify-content-center">
                                    <input
                                        class="form-control small-input mr-3"
                                        type="text"
                                        id="days-autopush-budget"
                                        v-model="configurations[bookingType][`days_autopush${addressType['postfix']}`]"
                                    >
                                    <label for="days-autopush-budget" class="mb-0">Days autopush</label>
                                </div>
                                <div class="text-danger mb-1" v-if="errors[`configurations.${bookingType}.days_autopush${addressType['postfix']}`]">
                                    {{ errors[`configurations.${bookingType}.days_autopush${addressType['postfix']}`][0] }}
                                </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="mt-5">
            <div class="h4">External driver fees</div>
            <div>
                <table class="table table-bordered table-striped" aria-label="External driver fees table">
                    <tr>
                        <td style="width: 34%;">Cost prices for driver fees</td>
<!--                        <td v-for="bookingType in bookingTypes" style="width: 33%;">-->
                        <td>
                            <div class="d-flex align-items-center mb-4">
                                <div class="address-type-label bold-font" style="width: 30%;">Empty value</div>
                                <div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <input
                                            class="form-control small-input mr-3"
                                            type="number"
                                            id="cost_price_empty"
                                            v-model="configurations[0]['driver_fees_cost_price_empty']"
                                        >
                                        <span>kr.</span>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.driver_fees_cost_price_empty`]">
                                        {{ errors[`configurations.driver_fees_cost_price_empty`][0] }}
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center mb-4">
                                <div class="address-type-label bold-font" style="width: 30%;">2-mands</div>
                                <div>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <input
                                            class="form-control small-input mr-3"
                                            type="number"
                                            id="cost_price_2_mands"
                                            v-model="configurations[0]['driver_fees_cost_price_2_mands']"
                                        >
                                        <span>kr.</span>
                                    </div>
                                    <div class="text-danger mb-1" v-if="errors[`configurations.driver_fees_cost_price_2_mands`]">
                                        {{ errors[`configurations.driver_fees_cost_price_2_mands`][0] }}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 34%;">Fees/Bonuses for external drivers</td>
                        <!--                        <td v-for="bookingType in bookingTypes" style="width: 33%;">-->
                        <td>
                            <table class="table table-bordered table-striped" aria-label="External driver fees table">
                                <thead>
                                <tr>
                                    <th style="width: 50%;">Årsag</th>
                                    <th style="width: 15%;">Beløb</th>
                                    <th>Stk</th>
                                    <th class="text-right" style="width: 5%"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                     v-for="(item, index) in configurations[0]['driver_fees_fees_bonuses']"
                                >
                                    <td style="width: 50%;">
                                        <input v-model="configurations[0]['driver_fees_fees_bonuses'][index]['reason']"
                                               class="form-control"
                                               type="text"
                                        >
                                        <div class="text-danger mb-1" v-if="errors[`configurations.0.driver_fees_fees_bonuses.${index}.reason`]">
                                            {{ errors[`configurations.0.driver_fees_fees_bonuses.${index}.reason`][0] }}
                                        </div>
                                    </td>
                                    <td style="width: 15%;">
                                        <div class="d-flex align-items-center justify-content-center">
                                            <input v-model="configurations[0]['driver_fees_fees_bonuses'][index]['price']"
                                                   class="form-control"
                                                   type="number"
                                            >
                                            <span class="ml-2">kr.</span>
                                        </div>
                                        <div class="text-danger mb-1" v-if="errors[`configurations.0.driver_fees_fees_bonuses.${index}.price`]">
                                            {{ errors[`configurations.0.driver_fees_fees_bonuses.${index}.price`][0] }}
                                        </div>

                                    </td>
                                    <td>
                                        <input v-model="configurations[0]['driver_fees_fees_bonuses'][index]['stk']"
                                               class="form-control"
                                               type="text"
                                        >
                                        <div class="text-danger mb-1" v-if="errors[`configurations.0.driver_fees_fees_bonuses.${index}.stk`]">
                                            {{ errors[`configurations.0.driver_fees_fees_bonuses.${index}.stk`][0] }}
                                        </div>
                                    </td>
                                    <td>
                                    <span class="material-icons-outlined text-primary cursor-pointer"
                                          title="Remove"
                                          @click="removeDriverFeeOrBonus(index)"
                                    >delete</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4" class="text-center">
                                        <div class="mt-3">
                                            <span class="material-icons-outlined text-primary cursor-pointer"
                                                  title="Add driver fee or bonus"
                                                  @click="addDriverFeeOrBonus"
                                            >add_circle</span>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="mt-5">
            <button class="btn btn-primary" @click="save">Save configurations</button>
        </div>
    </div>

</template>

<script>
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue-select/dist/vue-select.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import moment from "moment/moment";
export default {
    name: "Configurations",
    components: {VueTimepicker, DatePicker},
    mixins: [datePickerOptionsMixin],
    props: {
        configurationsProp: {type: Array, required: true},
        bookingPrime: {type: String, required: true},
        bookingBudget: {type: String, required: true},
        bookingNamePrime: {type: String, required: true},
        bookingNameBudget: {type: String, required: true},
        today: {type: String, required: true},
        tomorrow: {type: String, required: true},
        dayAfterTomorrow: {type: String, required: true},
    },
    data() {
        return {
            configurations: {
                0: {},
                1: {permits: [], shorter_time_intervals: [], shorter_time_intervals_pickup: []},
                2: {permits: [], shorter_time_intervals: [], shorter_time_intervals_pickup: []}
            },
            errors: {},
            bookingTypes: [this.bookingBudget, this.bookingPrime],
            addressTypes: {
                pickup: {label: 'Pickup', postfix: '_pickup'},
                dropoff: {label: 'Dropoff', postfix: ''}
            },

        }
    },
    created() {
        let value;
        for (let i in this.configurationsProp) {
            value = this.configurationsProp[i]['value'];
            if (this.configurationsProp[i]['name'].includes('shorter_time_intervals')) {
                value = value ? JSON.parse(value) : [];
                for (let x = 0; x < value.length; x++) {
                    value[x].when = value[x].when === 'Before' ?
                        {name: 'Before', label: 'Før'} :
                        {name: 'After', label: 'Efter'}
                }

            } else if('permits' === this.configurationsProp[i]['name']) {
                if (value) {
                    value = JSON.parse(value);
                    value = value.join('; ');
                }

            } else if (this.configurationsProp[i]['name'].includes('send_sms_on_test_number')) { // boolean
                value = value && value === '1';

            } else if (this.configurationsProp[i]['name'].includes('shorter_time_interval_cut_off_time')) {
                value = value ? JSON.parse(value) : [];
                if (value.day) {
                    value.day = {name: value.day, label: value.day};
                }
            } else if (this.configurationsProp[i]['name'].includes('call_from_driver')) {
                value = value ? JSON.parse(value) : {enabled: false, price: 0};
            } else if (this.configurationsProp[i]['name'].includes('not_available_delivery_dates') ||
                this.configurationsProp[i]['name'].includes('driver_fees_fees_bonuses')
            ) {
                value = value ? JSON.parse(value) : [];
            }

            this.$set(
                this.configurations[this.configurationsProp[i]['booking_type']],
                this.configurationsProp[i]['name'],
                value
            );

            if (this.configurationsProp[i]['name'] === 'not_available_delivery_dates') {
                this.onDateChange('', this.configurationsProp[i]['booking_type']);
            }
        }

        for (let i = 0; i < this.bookingTypes.length; i++) {
            for (let j in this.addressTypes) {
                if (!this.configurations[this.bookingTypes[i]][`shorter_time_interval_cut_off_time${this.addressTypes[j]['postfix']}`]) {
                    this.$set(
                        this.configurations[this.bookingTypes[i]],
                        `shorter_time_interval_cut_off_time${this.addressTypes[j]['postfix']}`,
                        {enabled: false, day: '', time: ''}
                    );
                }

                if (!this.configurations[this.bookingTypes[i]][`call_from_driver${this.addressTypes[j]['postfix']}`]) {
                    this.$set(
                        this.configurations[this.bookingTypes[i]],
                        `call_from_driver${this.addressTypes[j]['postfix']}`,
                        {enabled: false, price: 0}
                    );
                }
            }
        }
    },
    methods: {
        save() {
            this.errors = {};
            let val;
            let data = JSON.parse(JSON.stringify(this.configurations));
            let addressType;
            for (let bookingType in data) {
                for (let j in this.addressTypes) {
                    addressType = this.addressTypes[j];
                    if (data[bookingType][`shorter_time_intervals${addressType['postfix']}`] &&
                        data[bookingType][`shorter_time_intervals${addressType['postfix']}`].length
                    ) {
                        for (let j = 0; j < data[bookingType][`shorter_time_intervals${addressType['postfix']}`].length; j++) {
                            val = data[bookingType][`shorter_time_intervals${addressType['postfix']}`][j]['when'].name;
                            this.$set(data[bookingType][`shorter_time_intervals${addressType['postfix']}`][j], 'when', val);
                        }
                    }

                    if (data[bookingType][`shorter_time_interval_cut_off_time${addressType['postfix']}`] &&
                        data[bookingType][`shorter_time_interval_cut_off_time${addressType['postfix']}`].day
                    ) {
                        this.$set(
                            data[bookingType][`shorter_time_interval_cut_off_time${addressType['postfix']}`],
                            'day',
                            data[bookingType][`shorter_time_interval_cut_off_time${addressType['postfix']}`].day.name
                        );
                    }

                    if (data[bookingType][`sms_flow_cut_off_day${addressType['postfix']}`] &&
                        data[bookingType][`sms_flow_cut_off_day${addressType['postfix']}`]['name']
                    ) {
                        this.$set(
                            data[bookingType],
                            `sms_flow_cut_off_day${addressType['postfix']}`,
                            data[bookingType][`sms_flow_cut_off_day${addressType['postfix']}`]['name']
                        );
                    }
                }

                if (data[bookingType].permits) {
                    val = data[bookingType].permits.split(';');
                    if (val.length) {
                        data[bookingType].permits = val.map((item) => {return item.trim()})
                    }
                }
            }
            axios.post(`/configurations`, {configurations: data})
                .then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: `Saved successfully!`,
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                }).catch((err) => {
                this.flashError(err, ``);
            });
        },
        addShorterTimeInterval(bookingType, addressTypeIndex) {
            this.configurations[bookingType][`shorter_time_intervals${this.addressTypes[addressTypeIndex]['postfix']}`].push({
                when: {name: 'Before', label: 'Før'},
                time: '00:00',
                price: '0',
            });
        },

        removeShorterTimeInterval(bookingType, index, addressTypeIndex) {
            this.configurations[bookingType][`shorter_time_intervals${this.addressTypes[addressTypeIndex]['postfix']}`].splice(index, 1);
        },
        flashError(error) {
            let er = error.response.data || error.response;
            console.error(er);
            this.flashMessage.error({
                title: '',
                message: error.response.data.message || error.response.data ||  'Error',
                time: 3000,
                blockClass: 'flash-message error'
            });

            if (error.response.data.errors) {
                this.errors = error.response.data.errors;
            }
        },
        changeOption() {
            const conf = JSON.parse(JSON.stringify(this.configurations));
            this.configurations = {};
            this.configurations = conf;
        },
        disabledDates(date) {
            const startFrom = moment().toDate();
            startFrom.setHours(0, 0, 0, 0);

            return date < startFrom ||
                date > new Date(
                    startFrom.getTime() + 365 * 24 * 3600 * 1000) ||
                [0,6].includes(date.getDay())
        },
        onDateChange(e, bookingType) {
            const startFrom = moment().toDate();
            startFrom.setHours(0, 0, 0, 0);
            let sorted = this.configurations[bookingType]['not_available_delivery_dates'].sort((a, b) => {
                return moment(a, 'DD-MM-YYYY') - moment(b, 'DD-MM-YYYY');
            });
            let removeIndexes = [];
            let d;
            sorted.forEach((date, index) => {
                d = moment(date, 'DD-MM-YYYY')
                if (date < startFrom) {
                    removeIndexes.push(index);
                }
            });

            let n = 0;
            if (removeIndexes.length) {
                removeIndexes.forEach(i => {
                    sorted.splice((i - n), 1);
                    n++;
                });
            }
            this.$set(this.configurations[bookingType], 'not_available_delivery_dates', sorted);
        },
        clearDates(e, bookingType) {
            this.$set(this.configurations[bookingType], 'not_available_delivery_dates', []);
        },
        addDriverFeeOrBonus() {
            this.configurations[0][`driver_fees_fees_bonuses`].push({
                reason: '',
                price: 0,
                stk: '',
            });
        },

        removeDriverFeeOrBonus(index) {
            this.configurations[0][`driver_fees_fees_bonuses`].splice(index, 1);
        },
    }
}
</script>

<style scoped>
.vue__time-picker {
    width: auto !important;
}
.time-picker input {
    margin-left: 0;
}

tr th:not(:first-child),
tr td:not(:first-child) {
    text-align: center;
}

.small-input {
    max-width: 140px;
}

.vue__time-picker input.display-time {
    border-radius: 0.25rem;
}

table td.vertical-align-top {
    vertical-align: top;
}
.address-type-label {
    min-width: 60px;
    text-align: left;
}

.bold-font {
    font-weight: bold;
    font-size: 1.1rem;
}

</style>
